// extracted by mini-css-extract-plugin
export default {"wrapper":"KeywordsSearchSection_wrapper__4ilrI","searchButton":"KeywordsSearchSection_searchButton__PWra5","searchInput":"KeywordsSearchSection_searchInput__C4Hr-"};